import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

let grids = document.querySelectorAll(".News")

//列じゃない&幅1024超えのときNewsのすべての画像が読み込まれた後にmasonryを適応
if (grids != null && window.innerWidth > 1024) {
    grids.forEach((grid, index) => {
        if (!grid.classList.contains("row")) {

            let cells = grid.querySelectorAll(".News__cell")

            cells.forEach((cell, ind) => {
                cell.style.float = "left"
            })

            imagesLoaded(grid, () => {

                let msnry = new Masonry(grid, {
                    gutter: '.News__gutter',
                    itemSelector: ".News__cell",
                    columnWidth: ".News__cellwidth",
                    percentPosition: true,
                })

                // function combination(array, n) {
                //     return n === 1 ?
                //         array.map(x => [x]) :
                //         array.flatMap((x, i) => {
                //             return combination(array.slice(i + 1), n - 1)
                //                 .map(y => [x].concat(y))
                //         })
                // }

                // function check(elm1, elm2) {

                //     const d1 = elm1.getBoundingClientRect();
                //     const d2 = elm2.getBoundingClientRect();

                //     return !(
                //         d1.top > d2.bottom ||
                //         d1.right < d2.left ||
                //         d1.bottom < d2.top ||
                //         d1.left > d2.right
                //     );
                // }

                //     combi = combination([...Array(cells.length)].map((_, i) => i), 2)

                // setTimeout(() => {

                //     function checkmsnry() {
                //         let checknum = 0
                //         combi.forEach((combo) => {
                //             if (check(cells[combo[0]], cells[combo[1]])) {
                //                 msnry.layout()
                //                 checknum++
                //             }
                //         })
                //         console.log(index + " " + checknum)
                //         if (checknum == 0) {
                //             console.log(index + "interval ended")
                //         } else {
                //             setTimeout(() => {
                //                 checkmsnry()
                //             }, 20)
                //         }
                //     }

                //     checkmsnry()
                // }, 1000)
            })
        }
    })
}